import moment from 'moment';
import React from 'react';

const SentMsg = ({message}) => {
  return (
    <div className="message-wrap sent-msg">
      <span className="message-time">
        {moment(message?.created_at).format('dddd, h:mma')}
      </span>
      <div className="message-content">
        <p>{message?.message}</p>
      </div>
    </div>
  );
};

export default SentMsg;
